import React from "react";
import { Container } from "reactstrap";
import { Typography, Breadcrumbs } from "@mui/material";
import { Link } from "react-router-dom";

function ContactUsPage() {
  return (
    <>
      <Container className="flex justify-center px-4 pt-2 pb-20">
        <Container className="max-w-7xl w-full mb-3 flex flex-col gap-3">
          <Breadcrumbs
            separator=">"
            aria-label="breadcrumb"
            sx={{
              fontFamily: "Poppins",
            }}
          >
            <Link underline="hover" color="inherit" to="/profile">
              Profile
            </Link>
            <Typography
              color="text.primary"
              sx={{
                fontFamily: "Poppins",
              }}
            >
              Contact us
            </Typography>
          </Breadcrumbs>

          <h1 className="font-semibold text-2xl">Contact us</h1>
          <hr className="w-[5%] border-black border-2" />
          <p className="font-semibold text-xl text-gray-600">
            Last updated on Nov 14th 2025
          </p>
          <p>You may contact us using the information below:</p>
          <div>
            <p>
              {/* Merchant Legal entity name: SUBS AND SCRIBES MEDIA VENTURES LLP */}
              Merchant Legal entity name: SOLMELU unit of S&SMV LLP
            </p>
            <p>
              Registered Address: SUBS AND SCRIBES MEDIA VENTURES LLP AEA FCI
              Godown Road, Jyothi Puram Dooravani Nagar, Bengaluru 560016
            </p>
            <p>
              Operational Address: SUBS AND SCRIBES MEDIA VENTURES LLP AEA FCI
              Godown Road, Jyothi Puram Dooravani Nagar, Bengaluru 560016
            </p>
            <p>Telephone No: 9964321365</p>
            {/* <p>E-Mail ID: navarangsmaranika@gmail.com</p> */}
          </div>

          <p className="italic mt-4">
            Disclaimer: The above content is created at SUBS AND SCRIBES MEDIA
            VENTURES LLP's sole discretion.
          </p>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4851.078597735318!2d77.66579158236505!3d13.000630033190236!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae113a25e2cd27%3A0xdc445c28b3719344!2sFCI%20Godown%20Rd%2C%20Dooravani%20Nagar%2C%20Bengaluru%2C%20Karnataka%20560016!5e0!3m2!1sen!2sin!4v1763093362707!5m2!1sen!2sin"
            className="w-full h-96"
            allowFullScreen={true}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </Container>
      </Container>
    </>
  );
}

export default ContactUsPage;
